<template>
  <div class="quick-service">
    <div class="quick-head">
      <h3 class="quick-title">快捷服务</h3>
      <a href="#/service">查看更多</a>
    </div>
    <div class="quick-body">
      <a
        :href="item.url"
        class="quick-card"
        v-for="(item, index) of list"
        :key="index"
        :style="{ color: item.color, backgroundImage: 'url(' + item.bg + ')' }"
        v-html="item.text"
        target="_blank"
      >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let base = "../../../../static/home2.0/";
    return {
      list: [
        {
          text: "安管证书查询",
          color: "#74938D",
          url: "https://www.eanguan.com/CertificatePrint.html",
          bg: base + "card1.png",
        },
        {
          text: "特种人员证书查询",
          color: "#618189",
          url: "https://www.etezhong.com/CertificatePrint.html",
          bg: base + "card2.png",
        },
        {
          text: "二级建造师<br />注册证书查询",
          color: "#727D93",
          url: "http://zjzw.hbcic.net.cn/jzs/cx.html",
          bg: base + "card3.png",
        },
        {
          text: "安管考试计划查询",
          color: "#A1827B",
          url: "https://www.eanguan.com/AdmissionTicketPrint.html",
          bg: base + "card4.png",
        },
        {
          text: "特种考试计划查询",
          color: "#88A681",
          url: "https://www.etezhong.com/AdmissionTicketPrint.html",
          bg: base + "card5.png",
        },
        {
          text: "安管准考证打印",
          color: "#948E75",
          url: "https://www.eanguan.com/AdmissionTicketPrint.html",
          bg: base + "card6.png",
        },
        {
          text: "特种准考证打印",
          color: "#87765F",
          url: "https://www.etezhong.com/AdmissionTicketPrint.html",
          bg: base + "card7.png",
        },
        {
          text: "安管考核成绩查询",
          color: "#5F8783",
          url: "https://www.eanguan.com/login",
          bg: base + "card8.png",
        },
        {
          text: "特种考核成绩查询",
          color: "#B280A3",
          url: "https://www.etezhong.com/login",
          bg: base + "card9.png",
        },
        {
          text: "建筑业<br />企业资质查询",
          color: "#5E7F87",
          url: "http://zjzw.hbcic.net.cn/hbzjt-form/zscx/zs_list.html?ssl=107",
          bg: base + "card10.png",
        },
      ],
    };
  },
};
</script>

<style lang="less">
.quick-service {
  padding: 16px 24px;
  background: #fff;
  .quick-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    border-bottom: 1px solid rgba(139, 139, 139, 0.2);
    h3 {
      font-size: 20px;
      font-weight: bold;
      color: #000;
      padding-left: 31px;
      background: url("../../../../static/home2.0/icon-send.png") no-repeat
        center left;
    }
    a {
      font-size: 16px;
      color: #666;
      padding-right: 18px;
      background: url("../../../../static/home2.0/icon-more.png") no-repeat
        center right;
      &:hover {
        color: #3482ff;
      }
    }
  }
  .quick-body {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .quick-card {
      position: relative;
      display: flex;
      margin-top: 14px;
      width: 150px;
      height: 74px;
      font-size: 16px;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-family: "ycy-b";
      padding-bottom: 0;
      transition: all 0.3s;
      &:hover {
        padding-bottom: 5px;
        color: #3482ff !important;
        box-shadow: 0 5px 20px 0px #dedede;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Home3.0/src/QuickService.vue